import type { DisplayMode, PopupInstance, DisplayConfig } from '../types';

export class CornerDisplayMode implements DisplayMode {
	createContainer(popup: PopupInstance): HTMLElement {
		const { display, feedId } = popup.config;
		const position = display.cornerPosition || 'bottom_right';

		const wrapper = document.createElement('div');
		wrapper.className = `gf-popups-corner gf-popups-corner--${position.replace('_', '-')} ${display.customCssClass}`;
		wrapper.dataset.feedId = String(feedId);
		wrapper.style.zIndex = String(display.zIndex);
		wrapper.style.width = display.popupWidth;
		wrapper.setAttribute('aria-hidden', 'true');

		if (display.showCloseButton) {
			const close = document.createElement('button');
			close.className = 'gf-popups-close';
			close.setAttribute('aria-label', 'Close');
			close.innerHTML = '&times;';
			close.addEventListener('click', () => popup.hide());
			wrapper.appendChild(close);
		}

		const content = document.createElement('div');
		content.className = 'gf-popups-content';
		wrapper.appendChild(content);

		return wrapper;
	}

	show(container: HTMLElement, config: DisplayConfig): void {
		container.removeAttribute('aria-hidden');
		requestAnimationFrame(() => {
			container.classList.add('gf-popups-corner--visible');
		});
	}

	async hide(container: HTMLElement, config: DisplayConfig): Promise<void> {
		container.classList.remove('gf-popups-corner--visible');
		container.setAttribute('aria-hidden', 'true');
		await new Promise(resolve => setTimeout(resolve, 300));
	}

	destroy(container: HTMLElement): void {
		container.remove();
	}
}
